import React from 'react';
import { routes } from '../Utility/constants';
import { Switch, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { logout } from 'redux/actions';
import Layout from 'hoc/layout';
import { Elements, StripeProvider } from 'react-stripe-elements';

import Login from 'scenes/AUTH/Login/index';
import Register from 'scenes/AUTH/Register';
import ForgotPass from 'scenes/AUTH/ForgotPassword/forgotPassword';
import ResetPassword from 'scenes/AUTH/ForgotPassword/resetPassword';

import Verification from 'scenes/AUTH/Verfication/verify';

import Home from 'scenes/HomePage/Home';
import Profile from 'scenes/Profile/Profile';

import Plans from 'scenes/Subscription/Plans';
import Payment from 'scenes/Subscription/Payment';
import Myplan from 'scenes/Subscription/MyPlan';
import { Stripkey } from 'config';

const Router = (props) => {
   let routeList = null;
   if (props.user) {
      if (props.user.verified) {
         if (props.user && props.user.subscription_status === 'inactive') {
            routeList = (
               <Switch>
                  <Route exact path={routes.PLANS} component={Plans} />
                  <Route exact path={routes.LOGOUT} component={logout} />
                  <Route exact path={routes.PROFILE} component={Profile} />
                  <Route exact path={routes.PAYMENT} component={Payment} />
                  <Route
                     exact
                     path={routes.RESETPASSWORD}
                     component={ResetPassword}
                  />
                  <Route
                     path="*"
                     render={() => <Redirect to={routes.PLANS} />}
                  />
               </Switch>
            );
         }
         if (props.user && props.user.subscription_status === 'active_paid') {
            routeList = (
               <Switch>
                  <Route exact path={routes.LOGOUT} component={logout} />
                  <Route exact path={routes.MYPLAN} component={Myplan} />
                  <Route exact path={routes.PROFILE} component={Profile} />
                  <Route exact path={routes.HOME} component={Home} />
                  <Route
                     exact
                     path={routes.RESETPASSWORD}
                     component={ResetPassword}
                  />
                  <Route
                     path="*"
                     render={() => <Redirect to={routes.HOME} />}
                  />
               </Switch>
            );
         }
         if (props.user && props.user.subscription_status === 'active_trial') {
            routeList = (
               <Switch>
                  <Route exact path={routes.LOGOUT} component={logout} />
                  <Route exact path={routes.MYPLAN} component={Myplan} />
                  <Route exact path={routes.PROFILE} component={Profile} />
                  <Route exact path={routes.HOME} component={Home} />
                  <Route
                     exact
                     path={routes.RESETPASSWORD}
                     component={ResetPassword}
                  />
                  <Route
                     path="*"
                     render={() => <Redirect to={routes.HOME} />}
                  />
               </Switch>
            );
         }
      } else {
         routeList = (
            <Switch>
               <Route
                  exact
                  path={routes.VERIFICATION}
                  component={Verification}
               />
               <Route
                  path="*"
                  render={() => <Redirect to={routes.VERIFICATION} />}
               />
            </Switch>
         );
      }
   } else {
      routeList = (
         <Switch>
            <Route exact path={routes.LOGIN} component={Login} />
            <Route exact path={routes.REGISTER} component={Register} />
            <Route exact path={routes.FORGOTPASSWORD} component={ForgotPass} />
            <Route
               exact
               path={routes.RESETPASSWORD}
               component={ResetPassword}
            />
            <Route path="*" render={() => <Redirect to={routes.LOGIN} />} />
         </Switch>
      );
   }
   return (
      <Layout>
         <StripeProvider apiKey={Stripkey()}>
            <Elements>{routeList}</Elements>
         </StripeProvider>
      </Layout>
   );
};

const mapStateToProps = (state) => {
   return {
      user: state.authReducer.user,
      subdata: state.authReducer.subdata,
   };
};

export default connect(mapStateToProps)(Router);
